import { render, staticRenderFns } from "./WkFormItem.vue?vue&type=template&id=ca780cce&scoped=true"
import script from "./WkFormItem.vue?vue&type=script&lang=js"
export * from "./WkFormItem.vue?vue&type=script&lang=js"
import style0 from "./WkFormItem.vue?vue&type=style&index=0&id=ca780cce&prod&lang=scss"
import style1 from "./WkFormItem.vue?vue&type=style&index=1&id=ca780cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca780cce",
  null
  
)

export default component.exports